import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminStateInstallRules from "@/pages/admin/AdminStateInstallRules";

export const Route = createFileRoute("/admin/state-rules")({
  head: () => pageHead("Admin \u2014 State Rules \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminStateInstallRules,
});
